export const categoryFragment = `
has_nicotine
page_layout
is_transparent_header
`
